export { Divider } from './divider';
export type { DividerProps } from './divider';
